'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'ice-cream';
var width = 448;
var height = 512;
var aliases = [127848];
var unicode = 'f810';
var svgPathData = 'M96 160C96 89.3 153.3 32 224 32S352 89.3 352 160c0 2 0 3.9-.1 5.9l-.5 11 10.1 4.4c22.7 9.9 38.5 32.5 38.5 58.7l0 48-352 0 0-48c0-26.3 15.8-48.9 38.5-58.7l10.1-4.4-.5-11c-.1-1.9-.1-3.9-.1-5.9zM224 0C136.7 0 65.7 69.9 64 156.8 35.3 173.4 16 204.4 16 240l0 80 82 0 107.6 191.4 18.4 32.6 18.4-32.6 107.6-191.4 82 0 0-80c0-35.6-19.3-66.6-48-83.2-1.7-86.9-72.7-156.8-160-156.8zm89.3 320L224 478.7 134.7 320 313.3 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIceCream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;